import { observable, action } from 'mobx';


class Cycle {
  @observable year;
  @observable month;

  static get storedYear() {
    return parseInt(localStorage.getItem('cycleYear'));
  }

  static get storedMonth() {
    return parseInt(localStorage.getItem('cycleMonth'));
  }

  static fromOther(cycle, monthIncrement) {
    const month0 = (cycle.month + monthIncrement) - 1;
    return new this(
      cycle.year + Math.floor(month0 / 12),
      (month0 % 12) + 1,
    );
  }

  constructor(year, month) {
    if ((year === undefined) || (year === null) || !isFinite(year)) {
      year = new Date().getFullYear();
    }
    if ((month === undefined) || month === null || !isFinite(month)) {
      // In JS, months are 0-indexed, but we stick to the Python API, 1-indexed
      month = new Date().getMonth() + 1;
    }
    this.year = year;
    this.month = month;
  }

  static fromPythonTimestamp(timestamp) {
    // We divide by 1 million because dates coming from Python are in microseconds
    // when JS expects seconds.
    const date = new Date(timestamp / 1e6);
    // We add 1 to the month because months are 0-indexed in JS when this class expects
    // regular 1-indexed months.
    return new this(date.getFullYear(), date.getMonth() + 1);
  }

  toString() {
    return `${this.year}-${this.month.toString().padStart(2, '0')}`;
  }

  get date() {
    return new Date(this.year, this.month - 1);
  }

  get shortYear() {
    return this.date.toLocaleDateString('en-US', { year: '2-digit' })
  }

  get shortMonth() {
    return this.date.toLocaleDateString('en-US', { month: 'short' });
  }

  get longMonth() {
    return this.date.toLocaleDateString('en-US', { month: 'long' });
  }

  updateStorage() {
    localStorage.setItem('cycleYear', this.year);
    localStorage.setItem('cycleMonth', this.month)
  }

  @action decrement = () => {
    this.month -= 1;
    if (this.month < 1) {
      this.year -= 1;
      this.month = 12;
    }
  };

  @action increment = () => {
    this.month += 1;
    if (this.month > 12) {
      this.year += 1;
      this.month = 1;
    }
  };

  get params() {
    return { cycle_year: this.year, cycle_month: this.month };
  }
}


export const cycle = new Cycle(Cycle.storedYear, Cycle.storedMonth);


export default Cycle;
